import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportInventorySnapShot } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import PageHeader from 'screens/components/basic/PageHeader';
import Pagination from 'screens/components/basic/Pagination';
import { getInventorySnapShot, getCsvReport } from 'actions/ReportsAction';
import { getProductTypes } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import WithRouter from 'custom/withRouter';


class IventorySnapShot extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();

        this.props.formInput(date, `InventorySnapShotSelectedDate`);
        this.props.getProductTypes();
    }

    getReport = () => {
        let branch = this.props.selectedBranches ? this.props.selectedBranches : this.props.loggedBranch;
        let selectedDate = this.props.selectedDate || moment().format("YYYY-MM-DD");
        let productId = 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let category = this.props.selectedCategory ? this.props.selectedCategory : "0";
        let iscannabis = this.props.isCannabis ? this.props.isCannabis : "2";
        let weight = this.props.weight ? parseFloat(this.props.weight) : "0";
        let species = this.props.species ? this.props.species : "0";
        let showZeroQuantity = this.props.showZeroQuantity ? this.props.showZeroQuantity : "0";
        let range = this.props.inventoryCountRange ? this.props.inventoryCountRange : null;
        let selectedWarehouseType = this.props.selectedWarehouseType ? this.props.showZeroQuantity == "0" ? this.props.selectedWarehouseType : "0" : "0"
        this.props.getInventorySnapShot({ branch, selectedDate, productId, pageNumber, pageSize, category, iscannabis, weight, species, showZeroQuantity, range, selectedWarehouseType });
    }

    downloadReport = () => {
        let branch = this.props.selectedBranches ? this.props.selectedBranches : this.props.loggedBranch;
        let selectedDate = this.props.selectedDate;
        let productId = 0;
        let pageNumber = 1;
        let pageSize = 9999;
        let category = this.props.selectedCategory ? this.props.selectedCategory : "0";
        let iscannabis = this.props.isCannabis ? this.props.isCannabis : "2";
        let weight = this.props.weight ? parseFloat(this.props.weight) : "0";
        let species = this.props.species ? this.props.species : "0";
        let showZeroQuantity = this.props.showZeroQuantity ? this.props.showZeroQuantity : "0";
        let selectedWarehouseType = this.props.selectedWarehouseType ? this.props.showZeroQuantity == "0" ? this.props.selectedWarehouseType : "0" : "0"
        this.props.getCsvReport(`reports/excel/inventorySnapShot?branch=${branch}&selectedDate=${selectedDate}&category=${category}&weightoption=${weight}&species=${species}&productId=${productId}&iscannabis=${iscannabis}&pageNumber=${pageNumber}&pageSize=${pageSize}&showZeroQuantity=${showZeroQuantity}&selectedWarehouseType=${selectedWarehouseType}`, "inventorySnapShot");
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    cleanSearch = () => {
        this.props.clearFormInput(`InventoryLevelWarehouse`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }


    render() {

        let categories = [];
        categories.push({ text: "All", value: "0", isCannabis: false }, { text: "All", value: "0", isCannabis: true });
        const cat = this.props.productTypes.length > 0 ? this.props.productTypes[0].categories : [];
        cat.map(item => {
            categories.push({
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            });
        });

        categories.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });

        return (
            <Grid headerContent={reportInventorySnapShot}>
                <PageHeader 
                    title={LOOKUP.report.inventorySnapShot.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-daily-inventory-snapshot-report" />}
                    description={LOOKUP.report.inventorySnapShot.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    categories={categories}
                    isCannabisOptions={this.props.isCannabisOptions}
                    weightOptions={this.props.weightOptions}
                    speciesOptions={this.props.speciesOptions}
                    showZeroQuantityOptions={this.props.showZeroQuantityOptions}
                    inventoryCountRangeOptions={this.props.inventoryCountRangeOptions}
                    warehouseTypesOptions={this.props.warehouseTypesOptions}
                    showZeroQuantity={this.props.showZeroQuantity}
                />
                {
                    this.state.showBody && this.props.canViewBaseCost &&
                        <h4 className="mt-2 validationMessage purpleText">
                            <i>Total Value (From Latest Cost): ${this.props.inventorySnapShot && this.props.inventorySnapShot[0] && this.props.totalValueFromLatestCost > 0 && this.formatNumber(this.props.totalValueFromLatestCost.toFixed(2))}</i>
                            <br />
                            <br />
                            <i>Total Value (From Weighted Avg Cost): ${this.props.inventorySnapShot && this.props.inventorySnapShot[0] && this.props.totalValueFromWAC > 0 && this.formatNumber(this.props.totalValueFromWAC.toFixed(2))}</i>
                        </h4>
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body inventorySnapShot={this.props.inventorySnapShot} selectedDate={this.props.selectedDate} allAccess={this.props.canViewBaseCost} />

                        <Pagination
                            length={this.props.TotalRows}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let isCannabis = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];

    let weightoptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "1G", value: "1"
        },
        {
            text: "3.5G", value: "3.5"
        },
        {
            text: "7G", value: "7"
        },
        {
            text: "14G", value: "14"
        },
        {
            text: "28G", value: "28"
        }
    ];
    let speciesOptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "Indica", value: "1"
        },
        {
            text: "Hybrid", value: "2"
        },
        {
            text: "Sativa", value: "3"
        },
        {
            text: "CBD", value: "4"
        },
        {
            text: "Blend", value: "5"
        },
        {
            text: "Others", value: "6"
        }
    ];

    let showZeroQuantityOptions = [
        {
            text: "true", value: "1"
        },
        {
            text: "false", value: "0"
        }
    ];

    let inventoryCountRangeOptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "Negative", value: "5"
        },
        {
            text: "1-5", value: "1"
        },
        {
            text: "6-10", value: "2"
        },
        {
            text: "11-15", value: "3"
        },
        {
            text: "16+", value: "4"
        }
    ];

    let warehouseTypesOptions = [
        {
            text: "All", value: "0"
        },
        {
            text: "Storage", value: "1"
        },
        {
            text: "Store", value: "2"
        },
        {
            text: "Damage", value: "3"
        }
    ];

    return {
        brachOptions: brachOptions,
        loggedBranch: state.common.branchId,
        selectedBranch: state.form.InventorySnapShotBranchOption,
        selectedDate: moment(state.form.InventorySnapShotSelectedDate).format("YYYY-MM-DD"),
        inventorySnapShot: state.reports.inventorySnapShot,
        productTypes: state.entity.productTypesList,
        selectedCategory: state.form.InventorySnapShotSelectedCategory,
        isCannabis: state.form.InventorySnapShotIsCannabis,
        weight: state.form.InventorySnapShotWeight,
        species: state.form.InventorySnapShotSpecies,
        showZeroQuantity: state.form.InventorySnapShotShowZeroQuantity,
        inventoryCountRange: state.form.InventorySnapShotInventoryCountRange,
        selectedWarehouseType: state.form.InventorySnapShotWarehouseType,
        isCannabisOptions: isCannabis,
        weightOptions: weightoptions,
        speciesOptions: speciesOptions,
        showZeroQuantityOptions: showZeroQuantityOptions,
        inventoryCountRangeOptions: inventoryCountRangeOptions,
        warehouseTypesOptions: warehouseTypesOptions,
        totalValueFromWAC: state.reports.totalValueFromWAC,
        totalValueFromLatestCost: state.reports.totalValueFromLatestCost,
        TotalRows: state.reports.InventorySnapshotTotalRow,
        selectedBranches: state.form.InventorySnapShotLocations,
        canViewBaseCost: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewBaseCost"))
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getInventorySnapShot: (model) => dispatch(getInventorySnapShot(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(IventorySnapShot));
